import * as React from 'react';

const SvgInfoFilled = (props) => (
  <svg
    data-type="monochrome"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <g fill="currentColor">
      <path d="M12 2.69922C6.83063 2.69922 2.625 6.90484 2.625 12.0742C2.625 17.2436 6.83063 21.4492 12 21.4492C17.1694 21.4492 21.375 17.2436 21.375 12.0742C21.375 6.90484 17.1694 2.69922 12 2.69922ZM12 6.54297C12.241 6.54297 12.4767 6.61445 12.6771 6.74837C12.8775 6.88228 13.0337 7.07263 13.126 7.29532C13.2182 7.51802 13.2424 7.76307 13.1953 7.99948C13.1483 8.2359 13.0322 8.45306 12.8618 8.62351C12.6913 8.79395 12.4742 8.91002 12.2378 8.95705C12.0014 9.00408 11.7563 8.97994 11.5336 8.8877C11.3109 8.79545 11.1206 8.63924 10.9866 8.43882C10.8527 8.2384 10.7813 8.00276 10.7812 7.76172C10.7812 7.43849 10.9097 7.12849 11.1382 6.89993C11.3668 6.67137 11.6768 6.54297 12 6.54297V6.54297ZM14.25 17.1367H10.125C9.92609 17.1367 9.73532 17.0577 9.59467 16.917C9.45402 16.7764 9.375 16.5856 9.375 16.3867C9.375 16.1878 9.45402 15.997 9.59467 15.8564C9.73532 15.7157 9.92609 15.6367 10.125 15.6367H11.4375V11.5117H10.6875C10.4886 11.5117 10.2978 11.4327 10.1572 11.292C10.0165 11.1514 9.9375 10.9606 9.9375 10.7617C9.9375 10.5628 10.0165 10.372 10.1572 10.2314C10.2978 10.0907 10.4886 10.0117 10.6875 10.0117H12.1875C12.3864 10.0117 12.5772 10.0907 12.7178 10.2314C12.8585 10.372 12.9375 10.5628 12.9375 10.7617V15.6367H14.25C14.4489 15.6367 14.6397 15.7157 14.7803 15.8564C14.921 15.997 15 16.1878 15 16.3867C15 16.5856 14.921 16.7764 14.7803 16.917C14.6397 17.0577 14.4489 17.1367 14.25 17.1367Z" />
    </g>
  </svg>
);

SvgInfoFilled.type = 'monochrome';
export default SvgInfoFilled;
